<template>
  <div class="center-middle">
    <Icon :size="size" icon="loader" :color="color" />
  </div>
</template>
<script>
import Icon from "@/components/display/icon/Icon";
export default {
  name: "LoadingState",
  components: { Icon },
  props: {
    size: {
      type: Number,
      default: 30,
    },
    color: {
      type: String,
      default: "gamma",
    },
  },
};
</script>
